import { CallabilityStart } from '@/App/Trader/components/ProductCheckboxes/CallabilityStart';
import { formChangeAction } from '@/store/state/rfs/rfs.actions';
import { selectRfs } from '@/store/state/rfs/rfs.selectors';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { format } from 'date-fns';
import type { PropsWithChildren, ReactElement } from 'react';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const NewPill = () => (
  <div className="position-absolute top-0 end-0 pe-16px pt-16px">
    <span className="badge rounded-pill badge-discreet-info">
      <FormattedMessage id="home.boost.pill" />
    </span>
  </div>
);

const CardContainer = ({ className, children }: PropsWithChildren<{ className: string }>) => <div className={className}>{children}</div>;

const StyledCardContainer = styled(CardContainer)`outline: 1px solid #000 !important`;

export function AmericanForwardCard({ children }: PropsWithChildren): ReactElement {
  const dispatch = useAppDispatch();

  const { callabilityStart } = useAppSelector(selectRfs);

  const handleDateChange = (date: string): void => {
    dispatch(formChangeAction({ callabilityStart: format(date, 'yyyy-MM-dd') }));
  };

  return (
    <StyledCardContainer className="card active p-16px">
      <NewPill />

      {/*HEADER*/}
      <div className="card-header p-0 mb-8px">
        <div className="fs-16 fw-semibold form-check-label">
          <FormattedMessage id="trader.checkbox.AmericanForward" />
        </div>
      </div>

      {/*BODY*/}
      <div className="card-body ps-0 pe-0 py-0">
        <div className="text-secondary">
          <FormattedMessage id="trader.checkbox.AmericanForward.description" />
        </div>
        <CallabilityStart date={callabilityStart} onChange={handleDateChange} />
      </div>
    </StyledCardContainer>
  );
}
